import Color from "color";
import { capitalizeName } from "../../utils";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

export default function StatusBadge({
  color = "#E0E0E0",
  title,
}: {
  title?: string;
  color?: string | null;
}) {
  let colorObj;
  if (color !== "null") {
    try {
      colorObj = Color(color ?? "#E0E0E0");
    } catch {
      colorObj = Color("#E0E0E0");
    }
  } else {
    colorObj = Color("#E0E0E0");
  }
  return (
    <div
      style={{
        background: colorObj.alpha(0.2).toString(),
        color: colorObj.darken(0.5).toString(),
        borderRadius: nawyTheme.nawy.radius.md,
        padding: "2px 8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "24px",
        width: "fit-content",
        fontSize: "12px",
        fontWeight: 400,
        textWrap: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {capitalizeName(title)}
    </div>
  );
}
